var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-list-group',{staticClass:"mt-2 mb-2 note-list",attrs:{"tag":"ul"}},_vm._l((_vm.vehiclesToValidate),function(vehicle,i){return _c('b-list-group-item',{key:i,staticClass:"flex-column align-items-start p-0",attrs:{"tag":"li"}},[_c('VehicleValidationCard',{attrs:{"vehicle":vehicle}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }